import type { Theme } from '@mui/material';

export const styles = {
  planActionStatistics: {
    // ChartJs' dimension calculation loops infinitely when its elements touch the viewport bottom.
    marginBottom: '1rem',
    position: 'relative',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },

  tabContent: (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[200],
    display: 'flex',
    flexDirection: 'column',
    p: 1,
    borderBottomRightRadius: '0.5rem',
    borderBottomLeftRadius: '0.5rem',
  }),

  header: (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[200],
    height: '1.5em',
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
    borderTopLeftRadius: '0.5rem',
    borderTopRightRadius: '0.5rem',
  }),

  tabRow: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    display: 'flex',
  },

  tab: (active: boolean) => (theme: Theme) => ({
    marginLeft: '4px',
    padding: '4px 16px',
    maxWidth: '100px',
    height: '3.75rem',
    textWrap: 'wrap',
    lineHeight: '1rem',
    fontWeight: 'normal',
    backgroundColor: active ? theme.colors.white : theme.colors.neutral[200],
    color: active ? theme.colors.neutral[800] : theme.colors.neutral[600],
    border: `1px solid ${theme.colors.neutral[500]}`,
    fontSize: 'small',
    cursor: 'pointer',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,

    '&:hover': {
      backgroundColor: active ? theme.colors.white : theme.colors.neutral[100],
    },
  }),

  overlay: (theme: Theme) => ({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    backgroundColor: theme.colors.white,
    opacity: 0.5,
    justifyContent: 'center',
    alignItems: 'center',
  }),
};
